var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"application-wrapper"},[_c('preloader',{attrs:{"load":_vm.preloading}}),_c('vue-snotify'),_c('main-header',{attrs:{"notifications":_vm.notifications}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }